import { IPersonaProps, ValidationState } from '@fluentui/react'

export * from 'shared-types'
export interface IPersonaPropsWithValidation extends IPersonaProps {
  validationState: ValidationState
}
